import { useState } from "react";
import Input from "ui/forms/Input";
import { Tooltip } from "ui/popovers/Tooltip";
import Label from "./Label";

export function Wrapper({ children }) {
  return <Tooltip.Provider>{children}</Tooltip.Provider>;
}

<Wrapper>

## Basic Label

export function BasicLabel() {
  const [name, setName] = useState("");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "300px" }}>
      <Label htmlFor="name-input">Full Name</Label>
      <Input id="name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter your name..." />
    </div>
  );
}

<BasicLabel />

---

## Required Label

export function RequiredLabel() {
  const [value, setvalue] = useState("");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "300px" }}>
      <Label htmlFor="required-input" required>
        Email Address
      </Label>
      <Input
        id="required-input"
        value={value}
        onChange={(e) => setvalue(e.target.value)}
        placeholder="user@example.com"
        type="email"
      />
    </div>
  );
}

<RequiredLabel />

---

## With Tooltip

export function TooltipLabel() {
  const [apiKey, setApiKey] = useState("");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "300px" }}>
      <Label htmlFor="api-input" tooltip="Find your API key in account settings">
        API Key
      </Label>
      <Input
        id="api-input"
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        placeholder="Enter API key..."
        type="password"
      />
    </div>
  );
}

<TooltipLabel />

</Wrapper>
